import { Injectable, inject } from '@angular/core';
import { BoelsAlternatesGateway } from '../gateway/boels-alternates.gateway';
import { of, switchMap } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from '../actions/boels-alternates.actions';

@Injectable({
  providedIn: 'any',
})
export class BoelsAlternatesEffects {
  private actions$ = inject(Actions);
  private boelsAlternatesGateway$ = inject(BoelsAlternatesGateway);

  loadAlternates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LOAD_ALTERNATES),
      map((action: fromActions.LoadAlternates) => action.payload),
      switchMap((payload) =>
        this.boelsAlternatesGateway$
          .getAlternates('rentalNL', payload.categoryId)
          .pipe(
            mergeMap((alternates) => [
              new fromActions.LoadAlternatesSuccess({
                categoryCode: payload.categoryId,
                alternates: alternates.alternates,
              }),
            ]),
            catchError((error) =>
              of(new fromActions.LoadAlternatesFail(error)),
            ),
          ),
      ),
    ),
  );
}
